<template>
    <div class="About-us container p-3" >
         <span class="backbutton"  @click="isBack()">
            <img class="back-image" src="@/assets/Back.png">
        </span>
                    
        <div ref="content ">
            <section>
                <div class="row border border-bottom-0 p-2 pt-5 pb-5">
                    <div class="col-md col about-desc">AT KWORKTECH, WE BELIEVE IN KAIZEN 
                        (CHANGE FOR BETTER). THIS PHILOSOPHY ALLOWS US TO CONTINUOUSLY IMPROVE BY BRINGING IN 
                        SMALL CHANGES WITH A LARGE GOAL TOWARDS 
                        <span class="specil-about pl-2"> "HUMANISING WORKPLACE"</span>
                    </div>
                </div>
            </section>
            <section>
                <div class="row border border-bottom-0">
                    <div class="col-md col-12 p-4"> 
                        <div class="text-inherit company-desc pb-3">
                            Workplaces today are continuously evolving and hence, are dynamically 
                            aligning with an organization’s way of working. 
                            The key set of factors that enable an organization to function successfully 
                            are their ability to be
                            <span class="special">Agile</span> and <span class="special">Flexible</span> while
                            being good at <span class="special">Communication</span>, <span class="special">Collaboration</span>, and
                            <span class="special">Innovation</span>
                        </div>
                        <div class="text-inherit company-desc">
                            In making this a reality, technology comes into play. How so? By making a 
                            workplace dynamic by understanding the utilization and optimization of spaces. 
                            This is where KWorkTech steps in. We do so by analyzing our clients' :
                            <div class="pl-3 pt-4">
                                <ul class="pl-5 ">
                                    <li>Thoughts</li>
                                    <li>Aspirations</li>
                                    <li>Needs</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md col-12 pr-0 company-desc-image text-center">
                        <img class="w-100 h-100" src="@/assets/Logos/Kwt.jpg">
                        <!-- <img class="w-70 logo" src="@/assets/KWorkTech_new_logo.jpg"> -->
                    </div>
                </div>
            </section>
            <!-- <section >
                <div class="row border p-4 border-bottom-0">
                    <div class="col">
                        <div class="row">
                            <div class="col-6 col-md p-2">
                                 <a href="https://www.actiu.com/en/" class="img-overlay d-block"  target="_blank">
                                    <img  src="@/assets/Logos/Actiu.png" class="w-100 "/>
                                 </a> 
                            </div>
                            <div class="col-6 col-md p-2">
                                <a href="https://www.allermuir.com/" class="img-overlay d-block"  target="_blank">
                                    <img  src="@/assets/Logos/Allermuir.png" class="w-100"/>
                                </a>
                            </div>
                            <div class="col-6 col-md p-2">
                                <a href="https://capdell.com/" class="img-overlay d-block"  target="_blank">
                                    <img  src="@/assets/Logos/Capdell.png" class="w-100"/>
                                </a>
                            </div>
                            <div class="col-6 col-md p-2">
                                <a href="https://www.figueras.com/en/" class="img-overlay d-block"  target="_blank">
                                    <img  src="@/assets/Logos/Figueras.png" class="w-100 "/>
                                </a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 col-md p-2">
                                <a href="https://koleksiyoninternational.com/" class="img-overlay d-block"  target="_blank">
                                    <img  src="@/assets/Logos/Koleksiyon.png" class="w-100"/>
                                </a>
                            </div>
                            <div class="col-6 col-md p-2">
                                <a href="https://sancal.com/en/" class="img-overlay d-block"  target="_blank">
                                    <img  src="@/assets/Logos/Sancal.png" class="w-100"/>
                                </a>
                            </div>
                            <div class="col-6 col-md p-2">
                                <a href="https://www.thesenatorgroup.com/in/resources/senator/" class="img-overlay d-block"  target="_blank">
                                    <img  src="@/assets/Logos/Senator.png" class="w-100"/>
                                </a>
                            </div>
                            <div class="col-6 col-md p-2">
                                <a href="https://www.busypod.com/" class="img-overlay d-block"  target="_blank">
                                    <img  src="@/assets/Logos/Busypod.png" class="w-100"/>
                                </a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 col-md p-2">
                                <a href="https://www.berenn.com/" class="img-overlay d-block"  target="_blank">
                                    <img  src="@/assets/Logos/deberenn.png" class="w-100"/>
                                </a>
                            </div>
                            <div class="col-6 col-md p-2">
                              
                            </div>
                            <div class="col-6 col-md p-2">
                                
                            </div>
                            <div class="col-6 col-md p-2">
                                
                            </div>
                        </div>
                    </div> 
                </div>
            </section> -->
            <section>
              
                        <!-- <div class="row">
                            <div class="col-6 col-md p-2">
                                <div v-for="(image, index) in filteredImages" :key="index">
                                    <img :src="image.brand_image" alt="Brand Image" class="w-25"/>
                                </div>
                            </div>
                        </div> -->

     <!-- <div class="row border">
        <div class="col-6 col-md p-2" v-for="(row, rowIndex) in chunkedImages" :key="rowIndex">
            <div class="d-flex flex-wrap">
                <div v-for="(item, columnIndex) in row" :key="columnIndex" class="w-75 p-1">
                <a :href="item.brand_url" class="img-overlay d-block"  target="_blank"> 
       
                <img :src="item.brand_image" alt="Brand Image" class="w-100"> 
             </a>
      </div>
                              
               
      </div>

   
    </div>
  </div> -->
  <div class="container">
    <div class="row">
      <div class="col-md-3 w-75 p-1" v-for="(item, index) in filteredImages" :key="index">
        <a :href="item.brand_url" class="img-overlay d-block" target="_blank">
          <img :src="item.brand_image" alt="Brand Image" class="img-fluid w-100">
        </a>
      </div>
    </div>
  </div>

            
            </section>
            <section>
                <div class="row border">
                    <div class="col-md col-12 p-4 border-right "> 
                        <div class=" text-center p-4">
                            <img  src="@/assets/ceo/Raj_Menon.png" class="w-50 ceo-image"/>
                        </div>
                        <div class="founder-details p-4 text-center">
                            <span class="founder-name">RAJ MENON</span><br>
                                <span class="text-uppercase text-center"> Director</span>

                        </div>
                        <div class="p-4">
                                Raj Menon comes with an eventful career that has spanned over 4 decades 
                                and has enabled him to have experienced - both nationally and internationally.
                                During these years, he worked in multiculturally dynamic environments in India,
                                Srilanka, and Bangladesh, all of which helped him adapt to different styles of management.<br>
                                At a time when the local market operated with very little awareness in terms of having variations 
                                in their catalogs, Menon, along with George Browny set-up "KWorkTech"- a one-step solution that sought 
                                to explore the possibilities of operating in the assorted markets of India, 
                                through interiors curated specially for office spaces.
                        </div>
                    </div>
                    <div class="col-md col-12 p-4"> 
                        <div class=" text-center p-4">
                            <img  src="@/assets/ceo/George_Browny.png" class="w-50 ceo-image"/>
                        </div>
                        <div class="founder-details p-4 text-center">
                             <span class=" founder-name">GEORGE BROWNY</span><br>
                             <span class="text-uppercase text-center"> Director</span>

                        </div>
                        <div class="p-4">
                            George Browny, with an extensive career of 20+ years,
                            is a competent professional who combines his knowledge of 
                            the market  with an analytical mindset, leading to the growth
                            of organizations. While working in the corporate sector as Regional Sales Head 
                            for the Southern Region, he handled their global accounts. It was then
                            that he first introduced European office furniture brands to India.<br>
                            His knowledge of Portfolio Management and Sales, 
                            along with his team-leading skills led him to establish "KWorkTech" along
                            with Raj Menon, enabling them to work with multiple brands to create inspiring
                            and world-class workplaces for the corporate sector.
                        </div>
                    </div>
                </div>
            </section>
            <section class="py-4">
                 <div class="row border text-uppercase content p-2">
                     <div class="col-12  col-md-12 col-lg-2 text-center text-md-left">
                         <span class=" title"> kworktech </span>
                     </div>
                     <div class="col-12 col-md text-center text-md-center">
                         <span class="p-1 d-block d-lg-inline" >
                            raj.menon@kaizenworktech.com
                         </span>
                         <span class="p-1">
                             +919845106710
                         </span>
                     </div>
                     <div class="col-12 col-md text-center text-md-center">
                        <span class="p-1 d-block d-lg-inline" >
                            george.browny@kaizenworktech.com
                        </span>
                        <span class="p-1 " >
                             +919845000173
                        </span>
                     </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue'
    import ProductService from '../../shared/services/product.service'

    const productService = new ProductService();
    export default Vue.extend ({  
        name: 'about-us',
        
        data() {
            return {
                filteredImages : []
            }
        },
        computed: {
    chunkedImages() {
      const chunkSize = 4; // Number of images per row
      const result = [];

    //   for (let i = 0; i < this.filteredImages.length; i += chunkSize) {
    //     const chunk = this.filteredImages.slice(i, i + chunkSize);

    //     while (chunk.length < chunkSize){
    //         chunk.push({brand_image: '', brand_url:''});
    //     }
    //     result.push
    //   }
    const images = this.filteredImages.slice();

    while(images.length > 0){
        result.push(images.splice(0,chunkSize));
    }

      return result;
    },
  },
      
        created() {
                productService.getAdminBrands()
                .then(response => {
                    this.brandsList = response.data.output.success[0].data ;
                    const filteredItems  = this.brandsList;
                    filteredItems.forEach(element => {
                        element.status = element.status === 1 ? true : false;
                    });
                    const filteredBrands = filteredItems.filter((item)=> item.status === true );
                    this.filteredImages = filteredBrands.map((
                            { brand_image , brand_url}) => ({ brand_image , brand_url}));
                    console.log("fitleredImge",this.filteredImages)
                })
                .catch(e => {
                this.errors.push(e)
                })

         },
        methods: {
              isBack(){
                this.$router.push({path:'/'})
            },
            
        },
          
    })
</script>

<style  scoped>
  @import '../../style.css';
  
.About-us{
    font-family: 'Barlow', sans-serif;
    color:#858585;
    text-align:justify
}
  .about-desc{
    font-weight: bold;
    font-size: 25px;
  }
  .specil-about{
      color:dodgerblue;
  }
  .company-desc{
    font-size: 18px;
  }
  .founder-name{
      font-size: 24px;
      font-weight: 600;
  }

  .logo{
      width: 70% !important;
  }
  .special{
      font-style: italic;
  }
    .backbutton{
        position: fixed;
        top: 15px;
        left: 55px;
        font-size: 28px;
        margin-right: 50px;
        cursor: pointer;
        z-index: 1;
    }
    .back-image{
        width: 22px;
        background:transparent;
    }
    .ceo-image{
        background: none;
    }
    img:hover {
        transform: scale(1.0);
        opacity: 0.5;
    }

    .img-overlay:hover{
        transform: scale(1.0);
        background: #333333;
    }
     @media(max-width:600px){
        .company-desc-image{
            padding-right: 15px !important;
        }
    }

</style>